import { waLink } from "@/lib/contactLinks";

export default function FloatingWhatsApp() {
  return (
    <a
      href={waLink("Hello AquaFionix, I'm interested in your Makhana export supply.")}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-50 grid place-items-center h-14 w-14 rounded-full bg-[#25D366] shadow-[0_10px_30px_rgba(37,211,102,0.5)] hover:scale-105 transition-transform"
    >
      <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white" aria-hidden="true">
        <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.115.553 4.1 1.523 5.82L4 29l8.383-1.49A11.94 11.94 0 0016 27c6.627 0 12-5.373 12-12S22.629 3 16.001 3zm0 21.8c-1.86 0-3.6-.51-5.09-1.4l-.36-.21-4.98.89.9-4.85-.24-.38A9.77 9.77 0 016.2 15c0-5.4 4.4-9.8 9.8-9.8s9.8 4.4 9.8 9.8-4.4 9.8-9.8 9.8zm5.62-7.34c-.31-.16-1.82-.9-2.1-1-.28-.1-.49-.16-.7.16-.2.31-.8 1-.98 1.2-.18.2-.36.23-.67.08-.31-.16-1.3-.48-2.48-1.53-.92-.82-1.54-1.83-1.72-2.14-.18-.31-.02-.48.14-.63.14-.14.31-.36.47-.55.16-.18.2-.31.31-.52.1-.2.05-.39-.03-.55-.08-.16-.7-1.69-.96-2.31-.25-.6-.5-.52-.7-.53l-.6-.01c-.2 0-.55.08-.83.39-.28.31-1.09 1.06-1.09 2.6 0 1.53 1.12 3.01 1.28 3.22.16.2 2.2 3.36 5.32 4.71.74.32 1.32.51 1.77.65.74.24 1.42.2 1.96.12.6-.09 1.82-.74 2.08-1.46.26-.72.26-1.33.18-1.46-.08-.13-.28-.2-.59-.36z" />
      </svg>
    </a>
  );
}
